export var PURCHASE_APPROVAL_PHASE;
(function (PURCHASE_APPROVAL_PHASE) {
    PURCHASE_APPROVAL_PHASE["\uBBF8\uC2B9\uC778"] = "\uBBF8\uC2B9\uC778";
    PURCHASE_APPROVAL_PHASE["\uC9C4\uD589\uC911"] = "\uC9C4\uD589\uC911";
    PURCHASE_APPROVAL_PHASE["\uBC1C\uC8FC\uC644\uB8CC"] = "\uBC1C\uC8FC\uC644\uB8CC";
    PURCHASE_APPROVAL_PHASE["\uBC18\uB824"] = "\uBC18\uB824";
})(PURCHASE_APPROVAL_PHASE || (PURCHASE_APPROVAL_PHASE = {}));
